export const SET_LOADING = "SET_LOADING";
export const SET_SPINLOADING = "SET_SPINLOADING";
